import { handleActions } from 'redux-actions';
import {
} from 'lodash';

import {
  INITIALIZE_FAILURE, INITIALIZE_REQUEST, INITIALIZE_SUCCESS, SET_PERIOD,
  FETCH_PURCHASES_REQUEST, FETCH_PURCHASES_FAILURE, FETCH_PURCHASES_SUCCESS,
} from './constants';

const initialState = {
  teria: {
    employeePurchases: [],
    guestPurchases: [],
    loading: false,
    error: '',
    hasError: false,
    start: {},
    end: {},
    initialized: false,
    initializing: false,
    initializeFailed: false,
    periodFrom: '1',
    showStores: false,
    showCafes: false,
  },
};

export default handleActions({
  [FETCH_PURCHASES_REQUEST]: state => ({
    ...state,
    fetchingEntries: true,
    employeePurchases: [],
    guestPurchases: [],
    error: '',
    hasError: false,
    loading: true,
  }),
  [FETCH_PURCHASES_SUCCESS]: (state, {
    employeePurchases,
    guestPurchases,
  }) => ({
    ...state,
    employeePurchases,
    guestPurchases,
    loading: false,
  }),
  [FETCH_PURCHASES_FAILURE]: (state, action) => ({
    ...state,
    loading: false,
    error: action.error,
    hasError: true,
  }),
  [INITIALIZE_REQUEST]: state => ({
    ...state,
    initialized: false,
    initializing: true,
    error: '',
    hasError: false,
    initializeFailed: false,
    loading: true,
  }),
  [INITIALIZE_SUCCESS]: (state, {
    periodFrom, showStores, showCafes
  }) => ({
    ...state,
    initialized: true,
    initializing: false,
    periodFrom,
    showStores,
    showCafes,
    initializeFailed: false,
    loading: false,
  }),
  [INITIALIZE_FAILURE]: (state, { error }) => ({
    ...state,
    error,
    hasError: true,
    initialized: false,
    initializing: false,
    initializeFailed: true,
    loading: false,
  }),
  [SET_PERIOD]: (state, {
    start, end,
  }) => ({
    ...state,
    start,
    end,
  }),
}, initialState.teria);



// WEBPACK FOOTER //
// ./src/sites/teria/reducer.js